import { render } from "./Posts.vue?vue&type=template&id=02e655ff"
import script from "./Posts.vue?vue&type=script&lang=ts"
export * from "./Posts.vue?vue&type=script&lang=ts"

import "./Posts.vue?vue&type=style&index=0&id=02e655ff&lang=scss"
script.render = render

export default script